export default __webpack_public_path__ + "static/media/IDFC-First.565de0b4.webp";